export default __webpack_public_path__ + "static/media/felicia wijaya.0cb69e6b.jpg";